import Contact from '../../apps/components/Contact';

export default {
  path: '/contacto',
  exact: 'true',
  component: Contact,
};